import { useSEO } from "@/hooks/useSEO";
import { SeoPageLayout } from "@/components/seo/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoContent";
import { Link } from "react-router-dom";

const SITE = "https://www.regard-de-nature.fr";

const NaturopatheVillefranche = () => {
  useSEO({
    title: "Naturopathe à Villefranche-de-Lauragais (31290) – Laura Elie",
    description:
      "Naturopathe à Villefranche-de-Lauragais : accompagnement personnalisé pour fatigue, stress, sommeil, digestion. Consultations le jeudi matin à La Maison Céleste avec Laura Elie.",
    canonical: `${SITE}/naturopathe-villefranche-de-lauragais`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Regard de Nature – Laura Elie, Naturopathe (Villefranche-de-Lauragais)",
      image: `${SITE}/regard-de-nature-logo.png`,
      "@id": `${SITE}/naturopathe-villefranche-de-lauragais`,
      url: `${SITE}/naturopathe-villefranche-de-lauragais`,
      telephone: "+33637031866",
      address: {
        "@type": "PostalAddress",
        streetAddress: "La Maison Céleste",
        addressLocality: "Villefranche-de-Lauragais",
        postalCode: "31290",
        addressCountry: "FR",
      },
      areaServed: [
        "Villefranche-de-Lauragais",
        "Montesquieu-Lauragais",
        "Avignonet-Lauragais",
        "Renneville",
        "Gardouch",
        "Saint-Léon",
        "Nailloux",
        "Caraman",
        "Baziège",
        "Lauragais",
      ],
      priceRange: "€€",
      openingHours: "Th 09:00-13:00",
    },
  });

  return (
    <SeoPageLayout
      h1="Naturopathe à Villefranche-de-Lauragais"
      intro="Consultations chaque jeudi matin à La Maison Céleste, dans un cadre apaisant pensé pour le ressourcement."
    >
      <SeoSection title="Pourquoi consulter à Villefranche-de-Lauragais ?">
        <p>
          Je consulte à <strong>Villefranche-de-Lauragais (31290)</strong>, au sein de <strong>La Maison
          Céleste</strong>, chaque <strong>jeudi matin</strong>. Un lieu chaleureux, dédié à la détente, idéal
          pour prendre le temps d'observer votre vitalité et vos besoins.
        </p>
        <p>
          La Maison Céleste se trouve au cœur de Villefranche-de-Lauragais, facilement accessible depuis l'A61
          et la gare SNCF. J'y accompagne des personnes de Villefranche et des communes alentour :{" "}
          <strong>Montesquieu-Lauragais</strong>, Avignonet-Lauragais, Renneville, Gardouch, Saint-Léon,
          Nailloux, Caraman, Baziège, Auterive.
        </p>
        <p>
          Pour celles et ceux qui préfèrent un cadre plus rural, je consulte également au cabinet de{" "}
          <Link to="/naturopathe-montesquieu-lauragais" className="text-primary underline hover:text-secondary">
            Montesquieu-Lauragais
          </Link>
          , à quelques minutes seulement.
        </p>
      </SeoSection>

      <SeoSection title="Mes accompagnements">
        <ul className="space-y-2">
          <li>
            👉{" "}
            <Link to="/naturopathe-stress" className="text-primary underline hover:text-secondary">
              Accompagnement du stress
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-fatigue" className="text-primary underline hover:text-secondary">
              Accompagnement de la fatigue
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-sommeil" className="text-primary underline hover:text-secondary">
              Accompagnement du sommeil
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-digestion" className="text-primary underline hover:text-secondary">
              Accompagnement digestion
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/iridologie" className="text-primary underline hover:text-secondary">
              Iridologie
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/fleurs-de-bach" className="text-primary underline hover:text-secondary">
              Fleurs de Bach
            </Link>
          </li>
        </ul>
      </SeoSection>
    </SeoPageLayout>
  );
};

export default NaturopatheVillefranche;
